"use strict";
var TYPES = {
    system: 'system',
    company_entity: 'company_entity',
    service_provider: 'service_provider',
    fund_admin: 'fund_admin',
};
var TABLES = {
    company_entity: 'company_entity'
};
var SYSTEM_CONTEXT = {
    context_id: 'system01-cc19-43a1-97b4-a3aa5e593395',
    fk_id: '',
    type: 'system',
    path: '/system01-cc19-43a1-97b4-a3aa5e593395'
};
var ContextConstants = {
    TYPES: TYPES,
    TABLES: TABLES,
    SYSTEM_CONTEXT: SYSTEM_CONTEXT
};
module.exports = ContextConstants;
